<template>
  <div>
    <div class="ad_container">
      <img class="top_img" src="./img/red_topImg.png" alt />
      <div class="inp_group" v-show="receiveState === 0">
        <div class="border_2">
          <div class="border_3">
            <div class="inner_body">
              <div class="inp_header">
                <img src="./img/red_icon_horn.png" alt />
                <p>Your friend <span>{{friendMobile}}</span> recommends to you the {{ curProInfo.proName }} loan platform</p>
              </div>
              <div class="inp_body">
                <div class="inp_style_one">
                  <input
                    type="tel"
                    maxlength="11"
                    v-model="phoneNum"
                    placeholder="Please enter your mobile number"
                    @keydown="replaceText('phone')"
                    @keyup="replaceText('phone')"
                  />
                </div>
                <div class="inp_style_two">
                  <input
                    type="tel"
                    v-model="SMSNum"
                    maxlength="6"
                    placeholder="Enter the code"
                    @keydown="replaceText('sms')"
                    @keyup="replaceText('sms')"
                  />
                  <p @click="onClickSMS"><span>{{seconds==180?btnName:seconds+' s'}}</span></p>
                </div>
              </div>
              <div :class="submitBtnClass" @click="onClickSubmit">Receive rewards</div>
            </div>
          </div>
        </div>
      </div>
      <div class="success_group" v-show="receiveState === 1">
        <div class="border_2">
          <div class="border_3">
            <div class="inner_body">
              <div  class="inner_body_title">
                <p>
                  <img src="./img/icon_success.png" alt />
                  Claim success</p>
              </div>
              <p class="inner_body_subtitle">
                Congratulations on obtaining a {{couponInfo.price}} cash coupon, which has been deposited into your account.</p>
                <p class="inner_body_subtitle color_orange">
                  <span class="danger">!</span>
                  <span style="padding-left: 5px">{{curProInfo.succTip}}</span>
                </p>
              <div class="inner_body_card">
                <div class="left">
                  <p></p>
                  <p>{{couponInfo.price}}</p>
                </div>
                <div class="right">
                  <p>{{couponInfo.type}}</p>
                  <p>Valid until {{voucherExpiredTime}}</p>
                </div>
              </div>
              <p class="inner_body_btn" @click="Download">{{ curProInfo.btnText }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="fail_group" v-show="receiveState === 2">
        <div class="border_2">
          <div class="border_3">
            <div class="inner_body">
              <div  class="inner_body_title">
                <p>
                  <img src="./img/icon_fail.png" alt />
                  Claim failed</p>
              </div>
              <p class="inner_body_subtitle">
                <img src="./img/red_icon_horn.png" alt />
                Sorry, you are already an old friend of {{ curProInfo.proName }} and cannot receive this event rewards. You can go to the APP to share this event with your friends to participate</p>
              <p class="inner_body_btn" @click="Download">Open {{ curProInfo.proName }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="product_container">
        <div class="product_header">
          <img src="./img/red_caitiao.png" alt />
          Event Description
          <img src="./img/red_caitiao.png" alt />
        </div>
        <div class="product_list">
          <p>1. Enter the mobile phone number you want to register to receive ₦100 cash coupon rewards, download and log in to {{ curProInfo.proName }} to view;</p>
          <p>2. You will receive a maximum of ₦900 cash coupons accumulatively during the process from {{ curProInfo.proName }}'s completion of credit certification to the first successful loan;</p>
          <p>3. The same mobile phone number is regarded as the same user and cannot be redeemed repeatedly. If you are an old user of {{ curProInfo.proName }}, you will not be able to get coupons, but you can share activities with your friends, and get up to ₦4200 cash and discount rewards after your friends register to use;</p>
          <p>4. Cash coupons can be withdrawn in {{ curProInfo.proName }};</p>
          <p>5. The above rewards can only be obtained by downloading the APP through the {{ curProInfo.proName }} link on the activity page and logging in.</p>
          <p>6. Cash coupon description: After receiving the cash coupon, you can check it in "My". If the cash coupon amount exceeds ₦1000 and there are no outstanding loans that need to be repaid, you can withdraw cash to your linked bank account. Validity period of the cash coupon: valid within 6 months from the date of receipt.</p>
          <p>7. The final interpretation right of this event belongs to {{ curProInfo.proName }};</p>
        </div>
      </div>
      <div class="rules_container">
        <div class="rules_header">
          <img src="./img/red_caitiao.png" alt />
          <p>{{ curProInfo.proName }} borrowing platform</p>
          <img src="./img/red_caitiao.png" alt />
        </div>
        <div class="rules_list">
          <ul>
            <li>
              <img src="./img/red_icon1.png" alt />
              <p>High quota Fast approval</p>
            </li>
            <li>
              <img src="./img/red_icon2.png" alt />
              <p>Safe and secure</p>
            </li>
            <li>
              <img src="./img/red_icon3.png" alt />
              <p>Low interest rate get quickly loan</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="bottom_download">
        <img :src="curProInfo.logo" alt />
        <p>Get loans up to ₦50,000 anytime, anywhere!</p>
        <div class="bottom_download_btn" @click="Download">{{curProInfo.downBtnText}}</div>
      </div>

      <verifyDialog v-if="needVerify" :callback="checkVerifyPic" />
    </div>
    <loading v-if="needLoading" />
  </div>
</template>
<script>
import {
  getStoreUuid, DateFormat, getParam, isNullOrEmpty,
} from '@/utils/tool';
import { BASE_URL } from '@/utils/main';
import verifyDialog from '../components/VerifyDialog/verify.vue';
import loading from '../components/Loading/loading.vue';

export default {
  components: {
    verifyDialog,
    loading,
  },
  data() {
    return {
      phoneNum: '',
      phoneHasInput: false,
      SMSNum: '',
      clickTimes: 0,
      codeToken: '',
      btnName: 'Get verification code',
      seconds: 180,
      coupons: 10,
      friendMobile: '',
      needVerify: false, // 是否要展示图形验证码框
      verifyPicCode: '',
      verifyPic: { url: '' },
      pictureStat: false, // 是否要传图形验证码相关参数
      captcheId: '',
      urlParam: {},
      needLoading: false,
      // 0未领取 1领取成功 2已领取或已注册
      receiveState: 0,
      couponInfo: {},
      downLoadUrl: '',
      curProInfo: {},
      configProInfo: {
        1: {
          downLoadUrl: 'https://lcredit.onelink.me/WB3X/ff75cd0',
          proName: 'LCredit',
          btnText: 'Download LCredit',
          downBtnText: 'Download now',
          succTip: 'You must download LCredit from the activity page and log in to view the rewards.',
          logo: require('./img/logo.png'),
        },
        2: {
          downLoadUrl: 'https://lcredit.onelink.me/WB3X/b952d955',
          proName: 'LCredit',
          btnText: 'Download LCredit',
          downBtnText: 'Download now',
          succTip: 'You must download LCredit from the activity page and log in to view the rewards.',
          logo: require('./img/logo.png'),
        },
        199: {
          downLoadUrl: 'https://lcredit.onelink.me/WB3X/b952d955',
          proName: 'LCredit Max',
          btnText: 'Download LCredit Max',
          downBtnText: 'Download now',
          succTip: 'You must download LCredit Max from the activity page and log in to view the rewards.',
          logo: require('./img/logo_lcreditmax.png'),
        },
        124: {
          downLoadUrl: 'https://lcredit.onelink.me/WB3X/b952d955',
          proName: 'LCredit',
          btnText: 'Download LCredit',
          downBtnText: 'Download now',
          succTip: 'You must download LCredit from the activity page and log in to view the rewards.',
          logo: require('./img/logo_inara.png'),
        },
        301: {
          downLoadUrl: 'https://web.ilcredit.ng/?ch=1536207044#/login',
          // downLoadUrl: 'https://ewdlgs.ilcredit.ng/galaxy/index.html?ch=1511207009#/login',
          proName: 'eLCredit',
          btnText: 'Go eLCredit',
          succTip: 'You must successfully register on the page and log in to eLCredit to see the reward.',
          downBtnText: 'Go now',
          logo: require('./img/logo_flypay.png'),
        },
        302: {
          downLoadUrl: 'https://web.flypay.ng/?ch=1536207044#/login',
          // downLoadUrl: 'https://ewdlgs.flypaywap.ng/galaxy/index.html?ch=1511207009#/login',
          proName: 'Flypay',
          btnText: 'Go Flypay',
          succTip: 'You must successfully register on the page and log in to Flypay to see the reward.',
          downBtnText: 'Go now',
          logo: require('./img/logo_flypay.png'),
        },
        304: {
          downLoadUrl: 'https://web.swiftkash.ng/?ch=1536209044#/login',
          proName: 'Swiftkash',
          btnText: 'Go Swiftkash',
          succTip: 'You must successfully register on the page and log in to Swiftkash to see the reward.',
          downBtnText: 'Go now',
          logo: require('./img/logo_swift.png'),
        },
        202: {
          downLoadUrl: 'https://bit.ly/flppinv',
          proName: 'Flypay',
          btnText: 'Download Flypay',
          downBtnText: 'Download now',
          succTip: 'You must download Flypay from the activity page and log in to view the rewards.',
          logo: require('./img/logo_flypayloan.png'),
        },
        131: {
          downLoadUrl: 'https://bit.ly/flytylj',
          proName: 'Flypay',
          btnText: 'Download Flypay',
          downBtnText: 'Download now',
          succTip: 'You must download Flypay from the activity page and log in to view the rewards.',
          logo: require('./img/logo_flypay.png'),
        },
        132: {
          downLoadUrl: 'https://bit.ly/flytylj',
          proName: 'Flypay Pro',
          btnText: 'Download Flypay Pro',
          downBtnText: 'Download now',
          succTip: 'You must download Flypay Pro from the activity page and log in to view the rewards.',
          logo: require('./img/logo_flypaypro.png'),
        },
        104: {
          downLoadUrl: 'https://bit.ly/swftyl',
          proName: 'Swiftkash',
          btnText: 'Download Swiftkash',
          downBtnText: 'Download now',
          succTip: 'You must download Swiftkash Pro from the activity page and log in to view the rewards.',
          logo: require('./img/logo_swift.png'),
        },
      },
    };
  },
  computed: {
    voucherExpiredTime() {
      return DateFormat(this.couponInfo.voucherExpiredTime * 1000);
    },
    submitBtnClass() {
      return {
        submitBtn: true,
        submitBtnDisable: this.phoneNum === '' || this.SMSNum === '',
      };
    },
  },
  beforeMount() {
    let b = getParam('b') || '718';
    let c = getParam('c') || '2';
    if (isNullOrEmpty(c)) {
      // 根据当前域名确定c值
      const { host } = window.location;
      if (host.includes('ilcredit')) {
        c = '301';
      } else if (host.includes('inara')) {
        c = '124';
      } else if (host.includes('swiftkash')) {
        c = '104';
      } else if (host.includes('flypaypro')) {
        c = '132';
      } else if (host.includes('flypayloan')) {
        c = '202';
      } else if (host.includes('flypay')) {
        c = '302';
      } else if (host.includes('.lcreditmax')) {
        c = '199';
      } else {
        b = '718';
        c = '2';
      }
    }
    this.curProInfo = this.configProInfo[c];
    document.title = this.curProInfo.proName;
    this.urlParam = {
      b,
      c,
    };
    const { href } = window.location;
    const urlArr = href.includes('?') ? href.split('?')[1].split('&') : [];
    if (urlArr.length > 0) {
      // const urlObj = {};
      // urlArr.forEach((maps) => {
      //   const [key, val] = maps.split('=');
      //   // 目前分享到facebook的链接中的“/#”会被过滤掉，从而导致系统会自动在链接后加上“/#”，这里需要处理下
      //   const [value] = val.split('#');
      //   urlObj[key] = value;
      // });
      const userGid = getParam('userGid');
      const activityId = getParam('activityId');
      this.urlParam = {
        userGid,
        activityId,
        b,
        c,
      };
      if (this.urlParam.userGid) {
        this.getUserMobile();
      }
    }
  },
  methods: {
    // 下载
    Download() {
      this.gtag('event', 'invite_red_download', {
        event_category: 'invite_red_download',
      });
      if (!this.downLoadUrl || this.downLoadUrl.length === 0) {
        window.location.href = this.curProInfo.downLoadUrl;
        return;
        // if (isIos()) {
        //   window.location.href = 'https://lcredit.onelink.me/WB3X/ff75cd0';
        // } else {
        //   window.location.href = 'https://lcredit.onelink.me/WB3X/b952d955';
        // }
      }
      window.location.href = this.downLoadUrl;
    },
    // 校验zuid
    checkzuid() {
      this.gtag('event', 'invite_mobilecheckzuid', {
        event_category: 'mobilecheckzuid_req',
      });
      const params = {
        // mobile: this.phoneNum.replace(/^[0]/, ''),
        mobile: this.phoneNum,
        zuid: getStoreUuid(),
        userGid: '',
      };
      const {
        b, c,
      } = this.urlParam;
      this.needLoading = true;
      this.$axios({
        method: 'post',
        url: `${BASE_URL}/userinfo/mobilecheckzuid?ek=1&t=&u=&c=${c}&b=${b}&bl=en_US`,
        data: params,
      }).then((res) => {
        this.getVerifycode(res);
      });
    },
    getVerifycode(res) {
      if (res.status === 200 && res.data.status === 0) {
        const param2 = {
          activityId: this.urlParam.activityId,
          codeToken: res.data.content.codeToken,
          codeType: 0,
          mobile: this.phoneNum,
          operationType: 5,
          userIP: '',
        };
        if (this.pictureStat) {
          Object.assign(param2, {
            pictureId: sessionStorage.getItem('captcheId') || '',
            verifyPicCode: this.verifyPicCode,
            pictureStatus: true,
          });
        }
        this.gtag('event', 'invite_getVerifycode', {
          event_category: 'verifycode_req_send',
        });
        const {
          b, c,
        } = this.urlParam;

        this.$axios({
          method: 'post',
          url: `${BASE_URL}/activity/sendVerificationCode?ek=1&t=&u=&c=${c}&b=${b}&bl=en_US`,
          data: param2,
        }).then((response) => {
          // this.clickTimes += 1;
          if (response.status === 200 && response.data.status === 0) {
            this.gtag('event', 'invite_getVerifycode', {
              event_category: 'verifycode_res_success',
            });
            this.codeToken = response.data.content;
            this.reciprocal();
          } else {
            this.gtag('event', 'invite_getVerifycode', {
              event_category: 'verifycode_res_failed',
            });
            // 状态码1618为图形验证码错误
            // if (this.clickTimes >= 3 && response.data.status === 1618) {
            if (response.data.status === 12 || response.data.status === 1617
              || response.data.status === 1618) {
              this.needVerify = true;
              this.pictureStat = true;
              this.needLoading = false;
            }
            this.$toast({ content: response.data.message });
          }
          this.needLoading = false;
        });
      } else {
        this.needLoading = false;
        this.$toast({ content: res.data.message });
      }
    },
    checkVerifycode() {
      const {
        activityId, userGid, b, c,
      } = this.urlParam;
      const param = {
        activityId,
        verifyToken: this.codeToken,
        mobile: this.phoneNum,
        userGid,
        verifyCode: this.SMSNum,
      };
      this.gtag('event', 'invite_red_checkVerifycode', {
        event_category: 'checRedkVerifycode_req',
      });
      this.needLoading = true;
      this.$axios({
        method: 'post',
        url: `${BASE_URL}/activity/reward?ek=1&t=&u=&c=${c}&b=${b}&bl=en_US`,
        data: param,
      }).then((res) => {
        if (res.status === 200) {
          if (res.data.status === 0) {
            this.gtag('event', 'invite_checkVerifycode', {
              event_category: 'checkVerifycode_res_success',
            });
            this.receiveState = 1;
            this.couponInfo = res.data.content;
          } else if (res.data.status === 2802 || res.data.status === 1001) { // 用户已经注册或领取过奖励
            this.receiveState = 2;
          } else {
            this.$toast({ content: res.data.message });
          }
        }
        this.needLoading = false;
      });
    },
    // 获取短信验证码
    onClickSMS() {
      this.needLoading = true;
      this.gtag('event', 'invite_click_getCode', { event_category: 'click_getCode' });
      if (this.seconds !== 180 || !this.checkPhoneValue()) {
        this.needLoading = false;
        return;
      }
      this.checkzuid();
    },
    // 倒计时
    reciprocal() {
      const that = this;
      setTimeout(() => {
        that.seconds -= 1;
        if (that.btnName !== 'resend') {
          that.btnName = 'resend';
        }
        if (that.seconds <= 1) {
          that.seconds = 180;
        } else {
          that.reciprocal();
        }
      }, 1000);
    },
    // 提交
    onClickSubmit() {
      if (this.phoneNum === '' || this.SMSNum === '') return;
      this.gtag('event', 'invite_red_ClickSubmit', {
        event_category: 'clickSubmit',
      });

      if (!this.checkPhoneValue()) return;
      if (!this.checkSMSvalue()) return;
      this.checkVerifycode();
    },
    // 校验手机号
    checkPhoneValue() {
      if (this.phoneNum[0] !== '0' || this.phoneNum.length !== 11) {
        this.$toast({
          content: 'Please enter the correct phone number',
        });
        return false;
      }
      return true;
    },
    // 校验验证码
    checkSMSvalue() {
      if (this.SMSNum.length < 6) {
        this.$toast({ content: 'Please enter correct verify code' });
        return false;
      }
      return true;
    },
    // 输入框去空格
    replaceText(type) {
      if (type === 'phone') {
        this.phoneNum = this.phoneNum.replace(/\D/g, '');
        if (this.phoneHasInput) {
          return;
        }
        this.phoneHasInput = true;
        this.gtag('event', 'invite_phoneInput', {
          event_category: 'phoneInput',
        });
      } else if (type === 'sms') {
        this.SMSNum = this.SMSNum.replace(/\D/g, '');
      }
    },
    // 大数据上报
    gtag(...values) {
      window.dataLayer.push(values);
    },
    // 获取用户手机号
    getUserMobile() {
      const { userGid, b, c } = this.urlParam;
      this.$axios({
        method: 'post',
        url: `${BASE_URL}/userinfo/baseinfo?b=${b}&c=${c}`,
        data: {
          userGid,
        },
      }).then((res) => {
        if (res.status === 200 && res.data.status === 0) {
          this.friendMobile = res.data.content.mobile;
          this.downLoadUrl = res.data.content.inviteUserDownloadUrl || '';
        }
      });
    },
    // 图形验证码输入完成
    checkVerifyPic(code) {
      this.verifyPicCode = code;
      this.needVerify = false;
      this.checkzuid();
    },
  },
};
</script>
<style lang="stylus" scoped>
px = (1 / 3.75vw);

input::-webkit-input-placeholder {
  color: #B2B2B2;
}

input::-moz-input-placeholder {
  color: #B2B2B2;
}

input::-ms-input-placeholder {
  color: #B2B2B2;
}

.ad_container {
  height: 100%;
  background: #2C82FF;
  background-size: contain;
  color: #2C82FF;
  padding-bottom: 50 * px;
  padding-top: 245 * px;
  .top_img{
    z-index: 100;
    position: absolute;
    top: 0;
  }
  img {
    width: 100%;
  }

  .success_group {
    box-sizing: border-box;
    width: 95%;
    background-color: #6BB5FF;
    padding: 9 * px;
    margin: 0 auto;
    border-radius: 5*px;
    .border_2 {
      box-sizing: border-box;
      background-color: #4798F6;
      border-radius: 5 *px;
      width: 99%;
      margin: auto;
      padding: 3 * px;

      .border_3 {
        box-sizing: border-box;
        background-color: #207FEC;
        width: 98%;
        margin: 2 *px auto;
        padding: 2 * px;
        border-radius: 5 *px;

        .inner_body {
          width: 99%;
          margin: 2px auto;
          background-color: #B2D8FF;
          padding-bottom 10 * px;
          &_title {
            background-image: url('./img/red_group_title.png');
            background-repeat: no-repeat;
            background-size: 180*px 46*px;
            background-position: center;
            color: #fff;
            font-size: 16*px;
            box-sizing: border-box;
            height:50* px;
            position: absolute;
            top: 250*px;
            width: 246*px;
            margin-left: 44 * px
            p{
              padding-top: 24*px;
              text-align:center;
            }
            img{
              width: 15*px;
              height: 15*px;
              margin-right:10*px;
            }
          }
          &_subtitle {
            width: 305*px;
            margin: 0 auto;
            color: #fff;
            font-size: 14*px;
            line-height: 20*px;
            padding-top: 50*px;
            img{
              width: 15 *px;
              height: 15 *px;
            }
          }
          .color_orange {
            color: #FF6E22;
            padding-top: 0;
            padding-left: 5*px;
          }
          .danger {
            padding: 0*px 6*px;
            border-radius: 10*px;
            background: #ff6e22;
            color: #fff;
          }
          &_card {
            background: url('./img/red_inviteBg.png') center no-repeat;
            width: 299*px;
            height: 86*px;
            margin: 0 auto;
            background-size: contain;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 8*px;
            margin-bottom: 8*px;
            .left {
              width: 90*px;
              color: #E67B00;
              font-size: 30*px;
              font-weight:bold;
              padding-left: 20*px;
              display: flex;
              align-items: baseline;
              p {
                &:first-child {
                  font-size:14 * px;
                  font-weight:bold;
                }
              }
            }
            .right {
              color: #808080;
              font-size: 11*px;
              text-align: left;
              line-height: 20 * px;
              p {
                &:first-child {
                  color: #454553;
                  font-size: 14*px;
                }
              }
            }
          }
          &_btn {
            width: 288 * px;
            height: 44 * px;
            margin: 0 auto;
            font-size: px * 16;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            background:linear-gradient(165deg,rgba(252, 198, 107, 1),rgba(255, 130, 31, 1));
            box-shadow: 0 2 * px 4 * px 0 rgba(23, 88, 153, 0.58);
            border-radius: 20 * px ;
          }
        }
      }
    }
  }

  .fail_group {
    box-sizing: border-box;
    width: 95%;
    background-color: #6BB5FF;
    padding: 9 * px;
    margin: 0 auto;
    border-radius: 5*px;
    .border_2 {
      box-sizing: border-box;
      background-color: #4798F6;
      border-radius: 5 *px;
      width: 99%;
      margin: auto;
      padding: 3 * px;

      .border_3 {
        box-sizing: border-box;
        background-color: #207FEC;
        width: 98%;
        margin: 2 *px auto;
        padding: 2 * px;
        border-radius: 5 *px;

        .inner_body {
          width: 99%;
          margin: 2px auto;
          background-color: #B2D8FF;
          padding-bottom 10 * px;

          &_title {
            background-image: url('./img/red_group_title.png');
            background-repeat: no-repeat;
            background-size: 180*px 46*px;
            background-position: top center;
            color: #fff;
            font-size: 16*px;
            box-sizing: border-box;
            height:50* px;
            position: absolute;
            top: 250*px;
            width: 246*px;
            margin-left: 44 * px

            p {
              padding-top: 22*px;
              text-align:center;
            }

            img {
              width: 15 *px;
              height: 15 *px;
              margin-right: 10 *px;
            }
          }

          &_subtitle {
            width: 295 *px;
            margin: 0 auto;
            color: #fff;
            font-size: 14 *px;
            line-height: 20 *px;
            padding-top: 45*px;
            padding-bottom: 15 *px;

            img {
              width: 15 *px;
              height: 15 *px;
            }
          }
          &_btn {
            width: 288 * px;
            height: 44 * px;
            margin: 0 auto;
            font-size: px * 16;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            background:linear-gradient(165deg,rgba(252, 198, 107, 1),rgba(255, 130, 31, 1));
            box-shadow: 0 2 * px 4 * px 0 rgba(23, 88, 153, 0.58);
            border-radius: 20 * px ;
          }
        }
      }
    }
  }

  .inp_group {
    width: 95%;
    box-sizing: border-box;
    background-color: #6BB5FF;
    padding: 9 * px;
    margin: 0 auto;
    border-radius: 5*px;
    .border_2{
      box-sizing: border-box;
      background-color: #4798F6;
      border-radius: 5*px;
      width: 99%;
      margin: auto;
      padding: 3 * px;
      .border_3{
        box-sizing: border-box;
        background-color: #207FEC;
        width: 98%;
        margin: 2*px auto;
        padding: 2 * px;
        border-radius: 5*px;
        .inner_body{
          width:99%;
          margin: 2px auto;
          background-color: #B2D8FF;
          padding-bottom 10 * px;
          .inp_header {
            width: 260 * px;
            margin: 0 auto;
            font-size: px * 14;
            color: #2C82FF;
            text-align: left;
            padding: 8 * px 0;
            display: flex;
            line-height: px*20;
            img{
              width: 15 *px;
              height: 15 *px;
            }
            p {
              transform: scale(0.95);
            }
            span{
              color: #FF9038;
            }
          }

          .inp_body {
            width: 100%;
            box-sizing: border-box;
            padding: 10 * px 10 * px 0;
            .inp_style_one {
              height: 44 * px;
              border: 1px solid #fff;
              background-color: #fff;
              border-radius: px * 20;
              margin-bottom: px * 14;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding: 0 18 * px;
              img {
                width: 20px;
              }
              input {
                border: none;
                outline: none;
                padding-left: px * 10;
                box-sizing: border-box;
                font-size: 14 * px;
                flex: 1;
              }
            }

            .inp_style_two {
              height: 44 * px;
              border: 1px solid #cecee5;
              background-color: #fff;
              border-radius: px * 20;
              margin-bottom: px * 14;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding: 0 18 * px;
              overflow: hidden;
              position: relative;
              p {
                position: absolute;
                right: 0;
                top: 0;
                width: px * 92;
                height: 100%;
                text-align: center;
                background: #FFEED6;
                cursor: pointer;
                color: #FF821F;
                font-size: 12px;
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 10;
              }
              img {
                width: 20px;
              }
              input {
                border: none;
                outline: none;
                padding-left: px * 10;
                box-sizing: border-box;
                font-size: 14 * px;
                width: 60%;
                padding-right: px * 10;
              }
            }
          }

          .submitBtn {
            width: 288 * px;
            height: 44 * px;
            margin: 0 auto;
            font-size: px * 16;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            background:linear-gradient(135deg,rgba(252, 198, 107, 1),rgba(255, 130, 31, 1));
            box-shadow: 0 2 * px 4 * px 0 rgba(23, 88, 153, 0.58);
            border-radius: 20 * px ;
          }
          .submitBtnDisable {
            background: #b2b2b2;
          }
        }
      }
    }
    .UnActiveSubmit {
      opacity: 0.6;
    }
  }

  .product_container {
    padding: 0 12*px;
    box-sizing: border-box;
    padding-top: 13px;
    margin: 20*px 16*px;
    background: #fff;
    border-radius: 9*px;
    .product_header {
      img {
        width: 15px;
        height: 15px;
      }
      height: px * 40;
      line-height: 40*px;
      text-align: center;
      color: #454553;
      font-size: px * 16;
      border-radius: 9*px 9*px 0 0;
      font-weight: bold;
    }

    .product_list {
      background: #fff;
      box-sizing: border-box;
      padding: 16*px 9*px;
      color: #273534;
      font-size: 12*px;
      border-radius: 0 0 9*px 9*px;
      p {
        line-height: 18*px;
      }
    }
  }

  .rules_container {
    margin: 20*px 16*px;
    padding-top: 20*px;
    background: #fff;
    border-radius: 9*px;
    box-sizing: border-box;
    .rules_header {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 12*px;
      img {
        width: 15px;
        height: 15px;
      }
      p {
        font-size: 20*px;
        color: #454553;
        line-height: 1;
        padding: 0 10*px;
        font-weight: bold;
      }
    }

    .rules_list {
      padding: 0 12*px 18*px;
      position: relative;
      .line {
        position: absolute;
        width: 200*px;
        height: 3*px;
        background: #5EC2A9;
        top: 50*px;
        left: 84*px;
        z-index: 1;
        opacity:0.32;
      }
      ul {
        box-sizing: border-box;
        background: #fff;
        border-radius: 9*px;
        padding: 20*px 0;
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        li {
          width: 33%;
          text-align: center;
          z-index: 10;
          img {
            width: 42*px;
            height: 42*px;
          }
          p {
            color: #273534;
            font-size: 12*px;
            font-weight: bold;
            margin-top: 10*px;
          }
        }
      }
    }
  }

  .bottom_download {
    position: fixed;
    width: 100%;
    height: 50 * px;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    background-color: rgba(24, 75, 146, 0.9);
    display: flex;
    align-items: center;
    padding-left: 13*px;
    z-index: 100;

    img {
      width: px * 35;
      height: 35*px;
      padding-right: 12*px;
    }
    p {
      width: 160*px;
      color: #fff;
      font-size: 13*px;
      line-height: 15*px;
    }

    .bottom_download_btn {
      position: fixed;
      right: 17*px;
      bottom: 12*px;
      x-inde: 999;
      width: 100*px;
      height: 25*px;
      color: #fff;
      font-size: 12*px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 13px;
      background:linear-gradient(0deg,rgba(252,167,45,1),rgba(250,226,66,1));
      box-shadow: 0 1*px 3*px 0 rgba(5,49,47,0.46);
      animation: change 0.5s;
      animation-iteration-count: infinite;
    }


    i {
      font-style: italic;
      font-weight: 130;
      font-size: px * 16;
    }
  }

  .dialog {
    .dialog_bg {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      background: #000000;
      opacity: 0.7;
    }
    .dialog_body {
      width: px * 300;
      position: fixed;
      top: 140px;
      left: px * 38;
      .btn-close {
        border: none;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        color: #FFFFFF;
        background: transparent;
        position: absolute;
        right: 6px;
        top: 5px;
      }
      .reward_msg {
        background: #FFFFFF;
        font-size: px * 14;
        font-weight: 400;
        color: #1C1C28;
        text-align: center;
        line-height: px * 20;
        margin-top: -5px;
        padding: 10px 18px 33px 18px;
      }
      .reward_received {
        background: #FFFFFF;
        color: #1C1C28;
        text-align: center;
        font-size: px * 16;
        font-weight: 130;
        line-height: px * 16;
        padding-bottom: px * 20;
        margin-top: -5px;
      }
      .download_block {
        width: px * 300;
        background: #FFFFFF;
        border-radius: 0 0 px * 5 px * 5;
        margin-top: -5px;
        .btn_download {
          border: none;
          color: #FFFFFF;
          font-size: px * 16;
          font-weight: 500;
          line-height: px * 16;
          background: -webkit-linear-gradient(left, #29D989, #29BB9C 100%);
          border-radius: px * 23;
          width: px * 280;
          height: px * 40;
          margin: 0 px * 10 px * 30 px * 10;
        }
      }
    }
  }
}

@keyframes change {
  from, 0%, to {
    transform: scale(1);
  }

  70% {
    transform: scale(1.02);
  }
}
</style>
